<script lang="ts">
  import { onMount } from "svelte";
  import { setHeadTitle } from "../app/store/store-ui";
  import PageLayout from "./layout/PageLayout.svelte";
  import UserInfo from "../components/auth/user-info/UserInfo.svelte";

  onMount(() => {
    setHeadTitle("User Information");
    return () => setHeadTitle("");
  })
</script>

<PageLayout hasFooter={false}>
  <UserInfo />
</PageLayout>
